import React from 'react';
import ContentTitles from '../../typography/content-titles/ContentTitles';
import HeroContent from '../../hero-content/HeroContent';

type Props = {
    title?: string;
    subTitle?: string;
    overline?: string;
    titleComponent?: React.ElementType;
    imageUrl: string;
    buttonCTA?: string;
    buttonLink?: string;
    tint?: string;
    align?: 'left' | 'right';
};

const ParallaxHero: React.FC<Props> = ({
    title,
    subTitle,
    overline,
    titleComponent = 'h2',
    imageUrl,
    buttonCTA,
    buttonLink,
    tint,
    align = 'left',
}) => {
    return (
        <HeroContent
            backgroundPosition="center bottom relative"
            className="hero-yoyo"
            src={imageUrl}
        >
            {tint && (
                <div className="absolute inset-0 bg-opacity-50" style={{ backgroundColor: tint }} />
            )}

            <div className="parallax-container max-w-6xl mx-auto px-4 lg:px-0 grid lg:grid-cols-3 gap-6">
                {align === 'right' && <div className="hidden lg:block" />}

                <div>
                    <ContentTitles
                        title={title}
                        subTitle={subTitle}
                        overline={overline}
                        titleComponent={titleComponent}
                        style="white"
                    />

                    {buttonCTA && buttonLink && (
                        <div className="parallax-content mt-4">
                            <a
                                href={buttonLink}
                                className="
                  inline-block px-6 py-2 rounded-xl bg-white text-black
                  font-medium border border-transparent
                  capitalize text-center whitespace-nowrap
                  hover:bg-gray-100 transition-all duration-200
                "
                            >
                                {buttonCTA}
                            </a>
                        </div>
                    )}
                </div>

                {align === 'left' && <div className="hidden lg:block" />}
            </div>
        </HeroContent>
    );
};

export default ParallaxHero;
